import { DefineGetters } from "vuex-type-helper";
import { SettingGetters, SettingState } from "./types";

export const getters: DefineGetters<SettingGetters, SettingState> = {};
